import React, { Component } from "react";
import { Button, Card, Modal, Space, Switch, Typography, Popover, message } from 'antd';
import PropTypes from 'prop-types';
import '../../../styles/card-encuesta.css';
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

const axios = require("axios").default;
const moment = require("moment")
// moment

const { Title, Paragraph } = Typography;
export default class CardEncuesta extends Component {


    constructor(props) {
        super(props)

        this.state = {
            status: this.props.status,
            id: null,
            update: false
        }
    }


    componentDidUpdate() {
        
        console.log('this.state.id',this.state.id);
        console.log('this.props.id',this.props.id);
        if (this.state.id?.toString() !== this.props.id?.toString()) {
            this.setState({
                status: this.props.status,
                id: this.props.id
            })
        }
    }

    /**
     * @methodOf CardEncuesta
     *
     * @function delete
     * @description Elimina una encuesta
     *
     * */
    delete = () => {
        const component = this;
        Modal.confirm({
            icon: <ExclamationCircleOutlined />,
            title: '¿Deseas eliminar esta encuesta?',
            content: 'La encuesta ' + this.props.nombre + ' será eliminada. ¿Estás seguro que deseas proceder?',
            onOk() {
                console.log('component.props.id', component.props.id)
                return axios.delete("/encuestas/delete", { params: { id: component.props.id } },)
                    .then(component.props.update)
                    .then(() => { message.success("Encuesta eliminada, ¡exitosamente!") })
                    .catch(() => Modal.error({ title: "No fue posible borrar la encuesta." }))
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    /**
     * @methodOf CardEncuesta
     *
     * @function clean
     * @description Limpia una encuesta
     *
     * */
    clean = () => {
        const component = this;
        Modal.confirm({
            icon: <ExclamationCircleOutlined />,
            title: '¿Deseas limpiar esta encuesta?',
            content: 'Se eliminarán todas las respuestas obtenidas de  ' + this.props.nombre + '. ¿Estás seguro que deseas proceder?',
            onOk() {
                console.log('component.props.id', component.props.id)
                return axios.delete("/encuestas/clean", { params: { id: component.props.id } },)
                    .then(component.props.update)
                    .then(() => { message.success("Respuestas eliminadas, ¡exitosamente!") })
                    .catch(() => Modal.error({ title: "No fue posible limpiar la encuesta." }))
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    /**
     * @methodOf CardEncuesta
     *
     * @function setStatus
     * @description Actualiza el estatus de la encuesta
     *
     * @param status
     * @description El status a actualizar.
     *
     * */
    setStatus = (status) => {
        console.log('status event', status);
        this.setState({ loading: true, status })
        setTimeout(() => {
            axios.put("/encuestas/status", {
                id: this.props.id,
                status
            })
                .then(e => {
                    console.log('eeee', e);
                    this.setState({ loading: false })
                })
                .catch(e => {
                    console.log(' ERROR ', e);
                    this.setState({ loading: false, })
                })
        },500)
    }



    render() {


        const { id, nombre, inicio, fin, resultados, tipo } = this.props;

        const { setStatus } = this

        return <Card className="survey">
            <Title className="survey-title" level={4}>{nombre}</Title>

            <div className="survey-actions-content">
                <Paragraph className="survey-date-title">Tipo</Paragraph>
                <Paragraph className="survey-dates">{tipo}</Paragraph>
                <Paragraph className="survey-date-title">Fechas</Paragraph>
                <Paragraph className="survey-dates">{moment(inicio).format("DD-MMM-YYYY")} - {moment(fin).format("DD-MMM-YYYY")}</Paragraph>
                <Paragraph className="survey-switch-label">Estatus</Paragraph>
                <Switch
                    loading={this.state.loading}
                    checked={this.state.status}
                    className="survey-switch"
                    onChange={setStatus} />
                <Paragraph className="survey-answers-label">Respuestas Registradas</Paragraph>
                <Paragraph className="survey-answers">{(resultados !== undefined) ? resultados : 0}</Paragraph>
                <Paragraph className="title-actions">Acciones</Paragraph>
                <Space className="survey-controls">
                    <Link to={"/admin/ver-encuesta/" + id}>
                        <Popover content={"Permite ver los resultados de la encuesta "} title="Ver Encuesta">
                            <Button type="primary" className="button-survey button-view">
                                <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M16 5.25225C15.9266 5.3157 15.8432 5.37095 15.7811 5.44419C14.7932 6.61316 13.7135 7.68048 12.4382 8.53093C11.4475 9.19166 10.385 9.6816 9.20875 9.89153C7.7608 10.1504 6.37188 9.93762 5.03387 9.34224C3.81017 8.79737 2.73857 8.02016 1.78222 7.08732C1.19911 6.51846 0.661904 5.90129 0.109396 5.30087C-0.057699 5.11935 -0.0245922 4.8365 0.149062 4.64709C0.452957 4.3153 0.739986 3.96711 1.04825 3.63974C2.09892 2.52444 3.2561 1.54677 4.6269 0.850684C5.81531 0.247099 7.06837 -0.0666901 8.40544 0.0119149C9.57417 0.0804181 10.6564 0.443769 11.678 1.00695C12.9195 1.69135 13.9852 2.60209 14.954 3.63311C15.2729 3.97247 15.5743 4.32825 15.8823 4.67802C15.9263 4.72822 15.961 4.78725 16 4.84218C16 4.97855 16 5.11524 16 5.25225ZM14.83 5.00633C14.4343 4.59058 14.0798 4.1985 13.7047 3.82757C12.7237 2.85748 11.6471 2.0225 10.3665 1.4871C9.3215 1.05051 8.24053 0.883831 7.11459 1.04704C6.07642 1.1973 5.13662 1.60233 4.25679 2.16266C3.06995 2.91841 2.07081 3.88882 1.15195 4.95046C1.13914 4.9653 1.13196 4.98518 1.11384 5.01833C1.37307 5.29897 1.62637 5.58435 1.89123 5.85805C2.78667 6.78426 3.76332 7.60661 4.90737 8.20641C6.76385 9.17935 8.65687 9.29931 10.5864 8.43781C11.6802 7.94945 12.6262 7.24074 13.4823 6.40828C13.939 5.9638 14.3668 5.49028 14.83 5.00633Z"
                                        fill="white" />
                                    <path
                                        d="M11 5.01547C10.9962 6.70837 9.69 8.00312 7.98812 7.99999C6.29375 7.99718 4.99688 6.6918 5.00001 4.99203C5.00313 3.28289 6.30844 1.99595 8.035 2.00001C9.71093 2.00345 11.0034 3.3182 11 5.01547ZM7.9875 6.99994C9.095 7.00276 9.99781 6.10584 10 5.00047C10.0022 3.90479 9.10125 3.00162 8.00437 2.99975C6.90563 2.99787 6.00219 3.89542 6 4.99141C5.9975 6.09115 6.89375 6.99713 7.9875 6.99994Z"
                                        fill="white" />
                                </svg>
                            </Button>
                        </Popover>
                    </Link>
                    <Link to={"/admin/encuestas/" + id}>
                        <Popover content={"Permite editar la encuesta"} title="Editar Encuesta">
                            <Button type="primary" className="button-survey button-edit">
                                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M11.5646 13.5527C11.5646 13.4858 11.5646 13.429 11.5646 13.3719C11.5646 12.1273 11.5637 10.8828 11.5663 9.63819C11.5666 9.5338 11.575 9.4248 11.6058 9.32589C11.7125 8.98245 12.0459 8.78608 12.4072 8.84173C12.7343 8.89191 12.9857 9.18258 12.999 9.52601C13.0004 9.55946 12.9999 9.5932 12.9999 9.62694C12.9999 11.155 13.0002 12.683 12.9999 14.211C12.9999 14.6903 12.7302 14.9737 12.2521 14.9974C12.161 15.002 12.0695 14.9991 11.9781 14.9991C8.25851 14.9991 4.53891 14.9991 0.819305 14.9991C0.285791 14.9991 0 14.7142 0 14.181C0 10.385 0 6.58877 0 2.79278C0 2.2942 0.289251 2.00094 0.783545 2.00065C2.19635 2.00007 3.60915 1.99921 5.02224 2.00151C5.40637 2.00209 5.68928 2.2547 5.74379 2.63158C5.79195 2.96493 5.57998 3.30145 5.24834 3.39978C5.14914 3.42919 5.04012 3.43669 4.93573 3.43698C3.83525 3.43957 2.73477 3.43871 1.63428 3.43871C1.57718 3.43871 1.5198 3.43871 1.45087 3.43871C1.45087 6.81426 1.45087 10.1786 1.45087 13.5527C4.81576 13.5527 8.17748 13.5527 11.5646 13.5527Z"
                                        fill="white" />
                                    <path
                                        d="M11.0193 2C11.6819 2.66264 12.3464 3.32695 13 3.98042C11.3248 5.65538 9.64618 7.33339 7.979 9C7.33119 8.35181 6.66254 7.6825 6 7.0193C7.66051 5.35908 9.33965 3.67968 11.0193 2Z"
                                        fill="white" />
                                    <path
                                        d="M15 2.2736C14.4242 2.84896 13.8427 3.4297 13.2716 4C12.514 3.24235 11.7526 2.48089 11 1.7283C11.5682 1.15927 12.1516 0.575045 12.7262 0C13.4787 0.752275 14.2376 1.5112 15 2.2736Z"
                                        fill="white" />
                                    <path
                                        d="M4 11C4.34085 9.97294 4.67075 8.97891 4.99561 8C5.66018 8.66595 6.32729 9.33414 7 10.0079C6.02768 10.3293 5.02815 10.6599 4 11Z"
                                        fill="white" />
                                </svg>
                            </Button>
                        </Popover>

                    </Link>
                    <Popover content={"Elimina los resultados de la encuesta"} title="Limpiar encuesta">
                        <Button type="primary" className="button-survey button-clean-surveys" onClick={this.clean}>
                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M0 12.9238C0.20361 12.7985 0.422302 12.8253 0.645602 12.8611C2.19739 13.1093 3.75924 13.248 5.33365 13.1917C6.78573 13.1397 8.20891 12.934 9.55332 12.3761C9.71001 12.3111 9.77955 12.2583 9.70875 12.0736C9.58809 11.7596 10.0954 11.0531 10.4486 11.0047C10.604 10.9834 10.7373 11.037 10.8604 11.1181C11.4893 11.5322 12.1181 11.9463 12.7449 12.3631C13.0143 12.5424 13.0817 12.8154 12.8924 13.0668C12.7038 13.3174 12.5811 13.6349 12.2086 13.7247C12.1064 13.7496 12.1215 13.8457 12.1311 13.9257C12.2128 14.584 12.297 15.2416 12.3398 15.9038C12.4256 17.2355 12.4684 18.566 12.1906 19.8854C12.1022 20.3054 12.0033 20.7226 11.6053 21C11.3678 21 11.1307 21 10.8931 21C10.8416 20.9358 10.7641 20.9307 10.6883 20.9173C10.4687 20.879 10.2509 20.8353 10.0313 20.7975C9.87088 20.7699 9.81893 20.7132 9.90524 20.5576C10.3363 19.7798 10.568 18.9454 10.6723 18.0782C10.7117 17.7512 10.7515 17.4223 10.695 17.0897C10.638 17.2111 10.5986 17.3352 10.5567 17.4589C10.2203 18.4501 9.77578 19.3949 9.19512 20.2826C9.07865 20.4606 8.9559 20.5012 8.74642 20.4236C8.05767 20.1679 7.38944 19.8724 6.74552 19.5293C6.46649 19.3807 6.19376 19.222 5.9206 19.0632C5.68473 18.9261 5.68557 18.9005 5.91055 18.7645C5.93987 18.7468 5.9692 18.7295 5.99895 18.7118C6.86198 18.1972 7.55535 17.5259 8.09328 16.7103C8.10668 16.6839 8.12009 16.6571 8.1335 16.6307L8.12428 16.6225C8.10585 16.6453 8.08741 16.6682 8.06856 16.691C7.89428 16.7545 7.77655 16.8908 7.63327 16.9936C6.81799 17.5787 5.93066 18.0187 4.91512 18.2082C4.74461 18.2402 4.60342 18.2134 4.46894 18.1058C4.23517 17.9187 3.98882 17.7453 3.75421 17.559C3.13458 17.0673 2.54345 16.5476 2.00845 15.9736C1.97242 15.935 1.9079 15.9007 1.92131 15.8463C1.93932 15.773 2.02437 15.7963 2.08134 15.7813C2.12114 15.7707 2.16388 15.7687 2.20535 15.764C2.93097 15.6816 3.62895 15.502 4.30094 15.2325C4.3663 15.2065 4.44841 15.1963 4.48696 15.1179C4.38222 15.0694 4.28628 15.1025 4.1916 15.1104C3.2565 15.1872 2.32392 15.1773 1.39385 15.0497C1.23088 15.0272 1.11022 14.9579 1.01679 14.8299C0.700485 14.3961 0.39884 13.9548 0.156268 13.4797C0.117306 13.4048 0.0909122 13.3193 0 13.2783C0 13.1602 0 13.042 0 12.9238Z"
                                    fill="white" />
                                <path
                                    d="M20 0.907026C19.9277 0.940008 19.8947 1.01051 19.8541 1.07235C18.1116 3.71015 16.3694 6.34835 14.6269 8.98615C14.2137 9.61159 13.7962 10.2337 13.3891 10.8633C13.2878 11.0199 13.2002 11.0422 13.0511 10.9288C12.7505 10.6996 12.443 10.479 12.1312 10.2655C11.9708 10.1554 11.964 10.054 12.0753 9.89689C13.0165 8.56974 13.9521 7.23806 14.8889 5.90762C16.1548 4.10965 17.4227 2.3125 18.6834 0.510408C18.8132 0.324468 18.9861 0.18223 19.1159 0C19.2364 0 19.357 0 19.4776 0C19.6041 0.200782 19.8043 0.303854 20 0.412284C20 0.577198 20 0.742112 20 0.907026Z"
                                    fill="white" />
                            </svg>
                        </Button>
                    </Popover>
                    <Popover content={"Elimina la encuesta."} title="Eliminar encuesta">
                        <Button type="primary" className="button-survey button-delete" onClick={this.delete}>
                            <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M1.26063 3.91361C0.979573 3.91361 0.717947 3.91384 0.45632 3.91361C0.124372 3.91315 0.000151068 3.78962 0.000151068 3.46207C0.000151068 3.29251 -0.000311578 3.12272 0.000382391 2.95316C0.00130768 2.6684 0.134319 2.534 0.417227 2.534C1.36565 2.53354 2.31385 2.53238 3.26227 2.53631C3.3548 2.53678 3.39551 2.50856 3.43021 2.42366C3.63401 1.92446 3.83294 1.42296 4.05617 0.932319C4.32266 0.346378 4.79432 0.0239132 5.43671 0.013041C6.4772 -0.00453957 7.51839 -0.00407693 8.55911 0.0128097C9.20658 0.0232192 9.6801 0.346378 9.94682 0.938565C10.1698 1.4336 10.3706 1.93858 10.5774 2.44078C10.607 2.51272 10.6438 2.53608 10.722 2.53585C11.6704 2.53284 12.6186 2.53377 13.567 2.534C13.8684 2.534 13.9987 2.66262 13.9994 2.96056C13.9998 3.14562 14.0005 3.33068 13.9994 3.51574C13.9977 3.76857 13.8599 3.91014 13.6059 3.91292C13.3246 3.91616 13.0433 3.91361 12.7403 3.91361C12.7403 3.97445 12.7403 4.02997 12.7403 4.08572C12.7403 7.11582 12.74 10.1459 12.7405 13.176C12.7405 13.7715 12.5788 14.309 12.1814 14.7634C11.8811 15.1066 11.5106 15.2852 11.0449 15.2843C8.35416 15.2797 5.66317 15.2788 2.97242 15.285C2.45657 15.2862 2.05823 15.0807 1.74155 14.6896C1.38809 14.2524 1.25994 13.7439 1.26017 13.1913C1.26156 10.1536 1.26086 7.11559 1.26086 4.07785C1.26063 4.02858 1.26063 3.97931 1.26063 3.91361ZM2.63885 3.91963C2.63885 3.98 2.63885 4.0258 2.63885 4.07184C2.63885 6.68579 2.63885 9.29951 2.63885 11.9135C2.63885 12.349 2.63909 12.7849 2.63885 13.2204C2.63862 13.418 2.69113 13.6007 2.78783 13.7719C2.8408 13.8656 2.90835 13.9105 3.02817 13.9105C5.68052 13.9063 8.33311 13.9068 10.9855 13.9102C11.0898 13.9105 11.1515 13.8709 11.2008 13.79C11.3181 13.5966 11.3627 13.3865 11.3625 13.161C11.3609 10.123 11.3614 7.08505 11.3616 4.04709C11.3616 4.00614 11.3616 3.96497 11.3616 3.91986C8.44877 3.91963 5.55121 3.91963 2.63885 3.91963ZM9.11174 2.52914C9.10735 2.50902 9.10619 2.49375 9.10087 2.48057C8.96855 2.15625 8.83531 1.83217 8.70299 1.50762C8.66829 1.42272 8.60537 1.38294 8.51469 1.38294C7.50867 1.38317 6.50288 1.38317 5.49685 1.38317C5.40664 1.38317 5.3421 1.42249 5.30694 1.50693C5.17046 1.83379 5.03398 2.16065 4.89819 2.48774C4.89333 2.49977 4.89495 2.51457 4.89356 2.52914C6.30186 2.52914 7.70368 2.52914 9.11174 2.52914Z"
                                    fill="white" />
                                <path
                                    d="M7.68699 8.90605C7.68699 9.83111 7.68723 10.7562 7.68676 11.681C7.68653 12.0021 7.56139 12.1254 7.23684 12.1258C7.06335 12.1263 6.88985 12.1268 6.71659 12.1256C6.45427 12.1235 6.31409 11.9866 6.31386 11.727C6.31317 9.84615 6.31317 7.96526 6.31386 6.08437C6.31386 5.83639 6.4515 5.6976 6.69948 5.69366C6.8961 5.69043 7.09272 5.69089 7.28912 5.69366C7.55167 5.69713 7.6863 5.83269 7.68653 6.09617C7.68769 7.0328 7.68699 7.96942 7.68699 8.90605Z"
                                    fill="white" />
                                <path
                                    d="M5.16259 8.90649C5.16259 9.82762 5.16259 10.749 5.16259 11.6701C5.16259 12.0071 5.04207 12.1263 4.70064 12.1265C4.54658 12.1265 4.39228 12.1265 4.23822 12.1265C3.91437 12.1263 3.78807 12.0021 3.78807 11.6812C3.78784 9.90812 3.78784 8.13526 3.78784 6.36217C3.78784 6.2657 3.78598 6.16947 3.78853 6.07301C3.79454 5.83799 3.92964 5.69942 4.16374 5.69457C4.36406 5.6904 4.56462 5.69179 4.76494 5.6941C5.0275 5.69711 5.16236 5.83359 5.16259 6.09661C5.16305 7.03347 5.16259 7.97009 5.16259 8.90649Z"
                                    fill="white" />
                                <path
                                    d="M8.83741 8.90362C8.83741 7.97856 8.83718 7.0535 8.83741 6.12844C8.83741 5.82147 8.96533 5.69401 9.27276 5.69332C9.45388 5.69285 9.63501 5.69124 9.81614 5.69378C10.0736 5.69725 10.2115 5.83211 10.2115 6.0868C10.2124 7.97162 10.2122 9.85644 10.2108 11.7413C10.2105 11.9809 10.0685 12.1218 9.82886 12.1255C9.6246 12.1287 9.42034 12.129 9.21608 12.1253C8.97967 12.1211 8.83787 11.9756 8.83764 11.7369C8.83671 10.7924 8.83741 9.84811 8.83741 8.90362Z"
                                    fill="white" />
                            </svg>
                        </Button>
                    </Popover>
                </Space>
            </div>
        </Card>
    }
}


CardEncuesta.propTypes = {
    id: PropTypes.string,
    nombre: PropTypes.string,
    inicio: PropTypes.string,
    fin: PropTypes.string,
    status: PropTypes.string,
    respuestas: PropTypes.string,
    update: PropTypes.func
};
